import { render, staticRenderFns } from "./RoutinesView.vue?vue&type=template&id=92733f08&"
import script from "./RoutinesView.vue?vue&type=script&lang=js&"
export * from "./RoutinesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports